import { writePlatformCookie, clearPlatformCookie } from '@goodsteward/gs-auth-spa';
import { useAuthStore } from '@/stores/auth';
import { getPlatformCookieDomain } from './config';

// Platform SSO cookie sync.
//
// Mirrors the auth store's access token into a `.goodstewardaba.com`-
// scoped cookie so the Lambda@Edge gate fronting the support site
// (and any future CloudFront-fronted authenticated app) sees the
// token on direct browser navigation.
//
// Pairs with installRefreshLoop: the refresh loop produces a fresh
// access token on a timer; this subscriber catches that update and
// re-writes the cookie so its Max-Age tracks the new expiry.
//
// In local dev VITE_PLATFORM_COOKIE_DOMAIN is unset, the cookie
// helper no-ops, and this whole module is effectively inert.

let unsubscribe: (() => void) | null = null;

export function installCookieSync() {
    if (unsubscribe) return; // Already installed.
    const domain = getPlatformCookieDomain();
    if (!domain) return; // Local dev — nothing to sync.

    const sync = () => {
        const { token, expiresAt } = useAuthStore.getState();
        if (token) {
            writePlatformCookie(token, { domain, expiresAt });
        } else {
            clearPlatformCookie({ domain });
        }
    };

    // Sync once on install in case a token is already present (full
    // page reload with a persisted store).
    sync();

    unsubscribe = useAuthStore.subscribe((s, prev) => {
        if (s.token !== prev.token || s.expiresAt !== prev.expiresAt) {
            sync();
        }
    });
}

export function uninstallCookieSync() {
    if (unsubscribe) unsubscribe();
    unsubscribe = null;
}
